import { StubBroadcastChannel } from './StubBroadcastChannel'

declare global {
  interface Window {
    fwnBroadcastChannelRegistry: Record<string, BroadcastChannel>
  }
}

window.fwnBroadcastChannelRegistry = window.fwnBroadcastChannelRegistry || {}

/**
 * Gets a BroadcastChannel from a cache or creates a new instance if one does
 * not exist yet.
 *
 * @param channel A BroadcastChannel name
 * @returns The BroadcastChannel instance
 */
export function getBroadcastChannel(channel: string) {
  if (!('BroadcastChannel' in window)) {
    // In the OneToOne product, BroadcastChannels are used to communicate tab
    // focus & monitoring state between tabs. This cross-tab communication
    // feature is not supported in older browsers, and by providing a stub here,
    // the product works in the first tab opened by the user.
    return new StubBroadcastChannel(channel)
  }

  const broadcastChannel = window.fwnBroadcastChannelRegistry[channel]
  if (broadcastChannel) {
    return broadcastChannel
  }
  const newBroadcastChannel = new BroadcastChannel(channel)
  window.fwnBroadcastChannelRegistry[channel] = newBroadcastChannel
  return newBroadcastChannel
}
